import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAlert } from "../../store/actions/AppAction";
import { withStyles } from "@material-ui/core/styles";
import history from "../../helpers/History";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import DoneIcon from "@material-ui/icons/Done";
import Tooltip from "@material-ui/core/Tooltip";
import { getFatura, getFaturaItens } from "../../services/FaturamentoService";
import { getUsuarioByToken } from "../../services/UsuarioService";
import Blocker from "../../components/Blocker";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { aceitaPreFatura } from "../../services/FaturamentoService";

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 1
  },
  button: {
    margin: theme.spacing(1)
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  title: {
    flexGrow: 1
  },
  rootRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fdfdfd"
    }
  }
});

class ConfirmaFatura extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fatura: "",
      empenho: "",
      user: "",
      password: "",
      idFatura: 0
    };
  }

  componentDidMount() {
    this.setState({
      fatura: sessionStorage.getItem("fatura"),
      empenho: sessionStorage.getItem("empenho"),
      user: sessionStorage.getItem("user"),
      password: sessionStorage.getItem("password"),
      idFatura: sessionStorage.getItem("idfatura")
    });

    if (sessionStorage.getItem("empenho") === null) {
      history.push("/faturamento/" + sessionStorage.getItem("fatura"));
    } else {
      sessionStorage.removeItem("empenho");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("password");
      sessionStorage.removeItem("idfatura");
      this.getFatura();
    }
  }

  handleCancel = () => {
    history.push("/faturamento/" + sessionStorage.getItem("fatura"));
  };

  handleConfirma = () => {
    aceitaPreFatura(this.state.idFatura, this.state.empenho)
      .then(result => {
        this.props.showAlert({
          message: "Fatura aprovada com sucesso!",
          options: {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "center" }
          }
        });
        history.push("/faturamento/" + sessionStorage.getItem("fatura"));
      })
      .catch(error => {
        if (error.message) {
          this.props.showAlert({
            message: error.message,
            options: {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "center" }
            }
          });
        }
      });
  };

  getFatura = () => {
    this.setState(
      {
        submitting: true
      },
      () => {
        getUsuarioByToken()
          .then(result => {
            this.setState(
              {
                usuarioLogado: result.data
              },
              () => {
                let params = { uuid: this.state.fatura };

                getFatura(params)
                  .then(result => {
                    this.setState({
                      dados: result.data,
                      submitting: false
                    });
                  })
                  .catch(error => {
                    this.setState({
                      dados: {},
                      submitting: false
                    });
                    console.log(error);
                  });
              }
            );
          })
          .catch(error => {
            this.setState({
              usuarioLogado: {},
              submitting: false,
              dados: {}
            });
            console.log(error);
          });
      }
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Blocker submitting={this.state.submitting}>
          <Card>
            <CardHeader
              style={{
                backgroundColor: "#efefef",
                paddingLeft: "12px",
                paddingRight: "6px",
                paddingTop: "3px",
                paddingBottom: "3px"
              }}
              action={
                <div>
                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 && (
                      <Tooltip title="Confirmar">
                        <IconButton
                          style={{ color: "green" }}
                          className={classes.button}
                          onClick={this.handleConfirma}
                          aria-label="Confirmar"
                        >
                          <DoneIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 && (
                      <Tooltip title="Cancelar">
                        <IconButton
                          style={{ color: "red" }}
                          className={classes.button}
                          onClick={this.handleCancel}
                          aria-label="Cancelar"
                        >
                          <CancelIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                </div>
              }
              title="Confirma o Pré-faturamento?"
            />

            <CardContent>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch"
                spacing={1}
              >
                <Grid item xs={12}>
                  {this.state.dados &&
                  Object.keys(this.state.dados).length > 0 ? (
                    <Card>
                      <CardContent>
                        <Table className={classes.table} size="small">
                          <TableBody>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"DataEmissao"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Empenho
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.empenho}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"Periodo eReferencia"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Periodo de Referencia
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_DATA_INICIO +
                                  " à " +
                                  this.state.dados.FATU_DATA_FIM}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"Orgao"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Órgão
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.ORGA_SIGLA +
                                  " (" +
                                  this.state.dados.ORGA_CODIGO +
                                  ") - " +
                                  this.state.dados.ORGA_NOME}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"NumeroDispositivos"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Qtde de dispositivos
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_EQUIPAMENTOS_FATURADOS &&
                                  this.state.dados.FATU_EQUIPAMENTOS_FATURADOS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 0,
                                      minimumFractionDigits: 0
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              variant="head"
                              key={"ValorTransacao"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor unitário
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_TRANSACAO &&
                                  "R$ " +
                                    this.state.dados.FATU_VALOR_TRANSACAO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"ValorServico"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor do Serviço
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_SERVICO &&
                                  "R$ " +
                                    this.state.dados.FATU_VALOR_SERVICO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"FatuImr"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                IMR
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_IMR &&
                                  this.state.dados.FATU_IMR.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaIssqn"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                % ISSQN
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_ISSQN &&
                                  this.state.dados.FATU_ALIQUOTA_ISSQN.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 1,
                                      minimumFractionDigits: 1
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"IssqnRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor ISSQN Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ISSQN_RETIDO &&
                                  "R$ " +
                                    this.state.dados.FATU_ISSQN_RETIDO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaIr"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                % IRRF
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_IR &&
                                  this.state.dados.FATU_ALIQUOTA_IR.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 1,
                                      minimumFractionDigits: 1
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"IrRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor IRRF a ser retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_IR_RETIDO &&
                                  "R$ " +
                                    this.state.dados.FATU_IR_RETIDO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaPis"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota de Pis Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_PIS &&
                                  this.state.dados.FATU_ALIQUOTA_PIS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"PisRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Pis Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_PIS_RETIDO &&
                                  "R$ " +
                                    this.state.dados.FATU_PIS_RETIDO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaCofins"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota Cofins Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_COFINS &&
                                  this.state.dados.FATU_ALIQUOTA_COFINS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"CofinsRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Cofins Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_COFINS_RETIDO &&
                                  "R$ " +
                                    this.state.dados.FATU_COFINS_RETIDO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaCsll"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota Csll Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_CSLL &&
                                  this.state.dados.FATU_ALIQUOTA_CSLL.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"CsllRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Csll Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_CSLL_RETIDO &&
                                  "R$ " +
                                    this.state.dados.FATU_CSLL_RETIDO.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"ValorNotaFiscalapagar"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor Nota Fiscal a pagar
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_NOTA_FISCAL &&
                                  "R$ " +
                                    this.state.dados.FATU_VALOR_NOTA_FISCAL.toLocaleString(
                                      "pt-BR",
                                      {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                      }
                                    )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </CardContent>
                    </Card>
                  ) : this.state.submitting ? (
                    <div />
                  ) : (
                    <div>
                      Nenhum faturamento encontrado para o identificador
                      solicitado.
                    </div>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Blocker>
      </div>
    );
  }
}

ConfirmaFatura.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAlert }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(ConfirmaFatura));
